const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userId: state => state.user.id,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  balance: state => state.user.balance,
  clicks: state => state.user.clicks,
  referral_token: state => state.user.referral_token,
  user: state => state.user,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permissionRoutes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  impersonating: state => state.user.impersonating,
  impersonator_name: state => state.user.impersonator_name,
  impersonator_id: state => state.user.impersonator_id,
  api_token: state => state.user.api_token,
  api_token_plain: state => state.user.api_token?.plain,
  ibot_settings_enabled: state => state.user.ibot_settings_enabled,
};
export default getters;
